/**
 * Every feature module, in a fixed order (orchestrator). The shell builds sections, routes and commands from this
 * list. Tracks never edit it; a feature's own index.ts is its entry.
 */
import type { FeatureModule } from '@/app/contract';
import agents from './agents';
import calendar from './calendar';
import calls from './calls';
import chat from './chat';
import chatinfo from './chatinfo';
import composer from './composer';
import discover from './discover';
import home from './home';
import me from './me';
import people from './people';
import spaces from './spaces';

export const FEATURES: readonly FeatureModule[] = [home, calendar, spaces, discover, people, me, chat, composer, chatinfo, agents, calls];
